<i18n>
{
    "en": {
        "Day": "Day",
        "Month": "Month",
		"Ordinarily": "Ordinarily",
        "DayOfMonthRepeat": "Day of month repeat",
        "TimeOfTheMonthRepeat": "Time of the month repeat"
    },
    "vi": {
        "Day": "Ngày",
        "Month": "Tháng",
		"Ordinarily": "Thứ tự",
        "DayOfMonthRepeat": "Vào ngày",
        "TimeOfTheMonthRepeat": "Vào thời điểm"
    }
}
</i18n>

<template>
	<div class="yearly-config-repeat">
		<div class="flex flex-wrap sm:flex-no-wrap mb-3">
			<vs-radio class="" vs-name="yearly-config" v-model="configMode" :vs-value="configModeOptions.dayOfMonth">
				<span class="whitespace-no-wrap">{{ $t("DayOfMonthRepeat") }}</span>
			</vs-radio>
			<select-day-of-month
				class="pl-16"
				v-model="localValue[configModeOptions.dayOfMonth]"
				:dayLabel="$t('Day')"
				:dayPlaceholder="`${$t('Actions.Choose')} ${$t('Day').toLowerCase()}`"
				:monthPlaceholder="`${$t('Actions.Choose')} ${$t('Month').toLowerCase()}`"
				:required="configMode === 0 ? 'required' : ''"
			/>
		</div>
		<div class="flex flex-wrap sm:flex-no-wrap mb-3">
			<vs-radio class="" vs-name="yearly-config" v-model="configMode" :vs-value="configModeOptions.timeOfTheMonth">
				<span class="whitespace-no-wrap">{{ $t("TimeOfTheMonthRepeat") }}</span>
			</vs-radio>
			<select-time-of-the-month
				class="pl-8"
				v-model="localValue[configModeOptions.timeOfTheMonth]"
				:dayLabel="$t('Day')"
				:ordinarilyLabel="$t('Ordinarily')"
				:dayPlaceholder="`${$t('Actions.Choose')} ${$t('Day').toLowerCase()}`"
				:monthPlaceholder="`${$t('Actions.Choose')} ${$t('Month').toLowerCase()}`"
				:ordinarilyPlaceholder="`${$t('Actions.Choose')} ${$t('Ordinarily').toLowerCase()}`"
				:required="configMode === 1 ? 'required' : ''"
			/>
		</div>
	</div>
</template>

<script>
import SelectDayOfMonth from "./SelectDayOfMonth";
import SelectTimeOfTheMonth from "./SelectTimeOfTheMonth";

export default {
	name: "YearlyConfigRepeat",
	components: {
		SelectDayOfMonth,
		SelectTimeOfTheMonth
	},
	props: {
		value: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			localValue: {},
			configMode: 0,
			configModeOptions: {
				dayOfMonth: 0,
				timeOfTheMonth: 1
			}
		};
	},
	watch: {
		sortedValue() {
			if (JSON.stringify(this.sortedValue) !== JSON.stringify(this.localValue[this.configMode])) {
				this.setInitData();
			}
		},
		localValue: {
			handler: function() {
				this.setNextValue();
			},
			deep: true
		},
		configMode() {
			this.setNextValue();
		}
	},
	computed: {
		sortedValue() {
			return {
				byday: this.value.byday,
				bysetpos: this.value.bysetpos,
				bymonthday: this.value.bymonthday,
				bymonth: this.value.bymonth
			};
		}
	},
	methods: {
		setInitData() {
			if (this.sortedValue.bymonth && this.sortedValue.bysetpos && this.sortedValue.byday) {
				this.configMode = this.configModeOptions.timeOfTheMonth;
			} else {
				this.configMode = this.configModeOptions.dayOfMonth;
			}
			this.localValue = {
				[this.configModeOptions.dayOfMonth]: {
					byday: null,
					bysetpos: null,
					bymonthday: this.sortedValue.bymonthday,
					bymonth: this.configMode === this.configModeOptions.dayOfMonth ? this.sortedValue.bymonth : null
				},
				[this.configModeOptions.timeOfTheMonth]: {
					byday: this.sortedValue.byday,
					bysetpos: this.sortedValue.bysetpos,
					bymonthday: null,
					bymonth: this.configMode === this.configModeOptions.timeOfTheMonth ? this.sortedValue.bymonth : null
				}
			};
		},
		setNextValue() {
			if (JSON.stringify(this.sortedValue) !== JSON.stringify(this.localValue[this.configMode])) {
				let nextValue = {};
				if (this.configMode === this.configModeOptions.dayOfMonth) {
					nextValue = { ...this.localValue[this.configModeOptions.dayOfMonth], byday: null, bysetpos: null };
				}
				if (this.configMode === this.configModeOptions.timeOfTheMonth) {
					nextValue = { ...this.localValue[this.configModeOptions.timeOfTheMonth], bymonthday: null };
				}
				this.$emit("input", nextValue);
			}
		}
	},
	created() {
		this.setInitData();
	}
};
</script>
